import React from "react";
import { useParams } from "react-router-dom";

import DivisionPageNew from "components/pages/UnitDivision/DivisionNew";

const DivisionNew = () => {
  const { id } = useParams();

  return <DivisionPageNew id={id} />;
};

export default DivisionNew;
